module.exports = _.toPlainObject;